__turbopack_context__.v({
  "billing": "Pricing-module__GqQ-iW__billing",
  "container": "Pricing-module__GqQ-iW__container",
  "cta": "Pricing-module__GqQ-iW__cta",
  "feature": "Pricing-module__GqQ-iW__feature",
  "featureText": "Pricing-module__GqQ-iW__featureText",
  "features": "Pricing-module__GqQ-iW__features",
  "included": "Pricing-module__GqQ-iW__included",
  "period": "Pricing-module__GqQ-iW__period",
  "periodActive": "Pricing-module__GqQ-iW__periodActive",
  "periodSave": "Pricing-module__GqQ-iW__periodSave",
  "periods": "Pricing-module__GqQ-iW__periods",
  "plan": "Pricing-module__GqQ-iW__plan",
  "planHead": "Pricing-module__GqQ-iW__planHead",
  "planName": "Pricing-module__GqQ-iW__planName",
  "planPro": "Pricing-module__GqQ-iW__planPro",
  "plans": "Pricing-module__GqQ-iW__plans",
  "price": "Pricing-module__GqQ-iW__price",
  "priceAmount": "Pricing-module__GqQ-iW__priceAmount",
  "priceTalk": "Pricing-module__GqQ-iW__priceTalk",
  "priceUnit": "Pricing-module__GqQ-iW__priceUnit",
  "priceVat": "Pricing-module__GqQ-iW__priceVat",
  "tagline": "Pricing-module__GqQ-iW__tagline",
});
